@if (!!mediaState) {
    <div class="event-details-column">
        <div class="options-panel" [ngClass]="{ collapsed: mediaState.collapsed }">
            <div class="media-header">{{ sitecore.media.Title }}</div>
            <ms-tab-bar [tabs]="mediaState.tabs" [scrollEnabled]="false" (select)="tabSelected($event)"></ms-tab-bar>
            <ms-expansion-panel
                class="expansion-panel"
                [collapsed]="mediaState.collapsed"
                (panelToggle)="panelToggled(mediaState.collapsed)"></ms-expansion-panel>
        </div>
        @if (!mediaState.collapsed) {
            <div
                id="mediaContainer"
                class="content-container media-container"
                aria-haspopup="true"
                [@toggleAnimation]="{ value: undefined, params: { mediaHeight: mediaHeight + 'px' } }">
                @if (isExpandedMediaEnabled && !mediaState.videoPlaying) {
                    <div
                        class="media-expander"
                        [ngClass]="{ 'media-expander--visible': deviceService.isTablet }"
                        [msClassAutoRemove]="'media-expander--mobile-expand'"
                        [msClassAutoRemoveTime]="EXPAND_BUTTON_FADE_TIME"
                        (click)="toggleExpand(!mediaState.isExpanded)"
                        [(msClassAutoRemoveIsClassVisible)]="isMobileExpand">
                        <span class="media-fullscreen">
                            <vn-icon size="15" [name]="mediaState.isExpanded ? 'theme-fullscreen-exit' : 'theme-fullscreen'" />
                        </span>
                    </div>
                }
                @switch (mediaState.activeTab) {
                    @case (tabType.Video) {
                        <div class="event-selector-container">
                            <ms-event-selector
                                [eventsList]="mediaState.videoDropdownEvents"
                                [selectedEventId]="mediaState.videoEventId"></ms-event-selector>
                            <ms-video-pin
                                [isPinned]="!!mediaState.videoPinned"
                                [disabled]="!mediaState.pinEnabled"
                                (toggle)="togglePin(!!mediaState.videoPinned)"></ms-video-pin>
                            @if (mediaState.videoUnpinInfoVisible) {
                                <ms-unpin-info></ms-unpin-info>
                            }
                        </div>
                        <div
                            class="video-container"
                            [ngClass]="getBackground(mediaState, tabType.Video)"
                            [ngStyle]="videoAndAnimationBgColor"
                            [style.height]="streamingMessageHeight">
                            @if (mediaState.videoEvent && (!mediaState.pendingEsport || mediaState.videoPinned)) {
                                <ng-container *msComponentProxy="videoStreamComponent"> </ng-container>
                            }
                            @if (isOnEventDetails && mediaState.pendingEsport && !mediaState.videoEvent) {
                                <ms-video-stream-button disabled [event]="mediaState.pendingEsport" [isEventPending]="true"></ms-video-stream-button>
                            }
                        </div>
                        @if (!mediaState.videoEvent && !mediaState.pendingEsport) {
                            <ms-empty-media
                                [isEventSelected]="mediaState.isEventDetailPage || mediaState.hasEventOnMedia"
                                [emptyList]="mediaState.videoDropdownEvents.length < 1"
                                [isEventLive]="mediaState.isEventLive"></ms-empty-media>
                        }
                    }
                    @case (tabType.Animation) {
                        <div class="animation" [ngClass]="getBackground(mediaState, tabType.Animation)" [ngStyle]="videoAndAnimationBgColor">
                            @if (!isAnimationDisabled()) {
                                @if (!mediaState.isAnimationAvailable) {
                                    <ms-match-simulation
                                        [runningBall]="mediaState.animationEvent?.runningBallDataId"
                                        [awayTeam]="(mediaState.animationEvent?.participants)[1].name"
                                        [homeTeam]="(mediaState.animationEvent?.participants)[0].name"
                                        [inColumn]="true"></ms-match-simulation>
                                } @else {
                                    <ng-container *msComponentProxy="animationComponent"></ng-container>
                                }
                            } @else {
                                <ms-empty-media [emptyList]="true"></ms-empty-media>
                            }
                        </div>
                    }
                    @case (tabType.Stats) {
                        <div [ngClass]="getBackground(mediaState, tabType.Stats)" [ngStyle]="statsBgColor">
                            @if (mediaState.statisticsEvent) {
                                <ndc-dynamic
                                    [ndcDynamicComponent]="eventStatisticsComponent$ | async"
                                    [ndcDynamicInputs]="{ event: mediaState.statisticsEvent, inColumn: true }"
                                    [ndcDynamicOutputs]="eventStatisticsComponentOutputs" />
                            }
                        </div>
                    }
                }
            </div>
        }
    </div>
}
